/**
 * 日ビューに重ねる、集中・運動のために取ってある時間の見た目（TODO 列右端の帯と、重なったタスクの印で共通）
 */

import { BookOpen, Brain, Dumbbell, Footprints, NotebookPen } from 'lucide-react'

import type { ExerciseSlotKind, FocusSlotKind } from '@/api/types/sleep'

/** TODO 列の右端に取る、集中・運動の時間を出す帯の幅（px）。タスクはこの帯を避けて置く */
export const SLOT_LANE_WIDTH = 16

export type SlotStyle = {
  icon: typeof Brain
  /** TODO 列の背景 */
  tint: string
  /** 右端の帯 */
  tab: string
  text: string
  /** 重なったタスクの左端の線 */
  border: string
}

export const SLOT_STYLE = new Map<FocusSlotKind | ExerciseSlotKind, SlotStyle>([
  [
    'deep',
    {
      icon: Brain,
      tint: 'bg-violet-500/10 border-violet-500/60',
      tab: 'bg-violet-500',
      text: 'text-violet-700 dark:text-violet-300',
      border: 'border-violet-500',
    },
  ],
  [
    'normal',
    {
      icon: BookOpen,
      tint: 'bg-sky-500/10 border-sky-500/60',
      tab: 'bg-sky-500',
      text: 'text-sky-700 dark:text-sky-300',
      border: 'border-sky-500',
    },
  ],
  [
    'review',
    {
      icon: NotebookPen,
      tint: 'bg-amber-400/10 border-amber-400/70',
      tab: 'bg-amber-400',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-400',
    },
  ],
  [
    'workout',
    {
      icon: Dumbbell,
      tint: 'bg-rose-500/10 border-rose-500/60',
      tab: 'bg-rose-500',
      text: 'text-rose-700 dark:text-rose-300',
      border: 'border-rose-500',
    },
  ],
  [
    'walk',
    {
      icon: Footprints,
      tint: 'bg-teal-500/10 border-teal-500/60',
      tab: 'bg-teal-500',
      text: 'text-teal-700 dark:text-teal-300',
      border: 'border-teal-500',
    },
  ],
])
